/**
 * PAPAPATTES — Ajout au panier depuis les cartes produit (grilles,
 * produits similaires, produits complementaires).
 *
 * MAJ 22/08 : le formulaire (snippets/pp-card-cart-button.liquid) n'est
 * plus un <product-form> Shopify — on gere l'appel /cart/add.js nous-memes
 * ici, pour eviter que Dawn ouvre automatiquement son tiroir/notification
 * panier (juge trop imposant) a chaque ajout depuis la grille. A la place :
 * mise a jour du badge panier du header + toast discret (pp-toast.js).
 */
(function () {
  function updateCartBubble(count) {
    const link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    let bubble = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        link.appendChild(bubble);
      }
      bubble.innerHTML = '<span aria-hidden="true">' + (count < 100 ? count : '') + '</span>';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.classList.toggle('pp-loading', isLoading);
    btn.disabled = isLoading;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.pp-card-cart-inner-form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('.pp-card-cart-btn');
    setLoading(btn, true);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();

      if (!res.ok) {
        const message = (data && data.description) || 'Ce produit est indisponible pour le moment.';
        if (window.ppToast) window.ppToast(message, { type: 'error' });
        return;
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartBubble(cart.item_count);

      if (window.ppToast) window.ppToast('Ajout\u00e9 au panier', { type: 'success' });
    } catch (err) {
      console.error('Ajout panier depuis la grille :', err);
      if (window.ppToast) window.ppToast('Une erreur est survenue.', { type: 'error' });
    } finally {
      setLoading(btn, false);
    }
  });
})();
